<template>
  <b-modal
    centered
    ref="editVendorRequestPart"
    id="editVendorRequestPart"
    body-class="modal-body-wo"
    hide-footer
    hide-header
    size="xl"
    title="Edit Part"
    :no-enforce-focus="true"
    @hidden="modalClosed"
    :no-close-on-backdrop="true"
  >
    <modal-window main-width="12">
      <h1>Edit part for vendor request</h1>
      <div class="row mt-3">
        <div class="col-5">
          <div class="label">Vendor</div>
        </div>
        <div class="col-7">
          <div>{{ vendorRequestPart.vendorName }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-5">
          <div class="label">Part</div>
        </div>
        <div class="col-7">
          <div>{{ vendorRequestPart.part.pn }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-5">
          <div class="label">Quantity</div>
        </div>
        <div class="col-7">
          <div>{{ vendorRequestPart.quantityRequested }}</div>
        </div>
      </div>
      <b-tabs>
        <b-tab title="Request">
          <EditVendorRequestPartRequest @close="cancel" @saved="cancel"></EditVendorRequestPartRequest>
        </b-tab>
        <b-tab title="Order / Shipment">
          <EditVendorRequestPartOrder @close="cancel" @saved="cancel"></EditVendorRequestPartOrder>
        </b-tab>
      </b-tabs>
      <template #sidebar></template>
    </modal-window>
  </b-modal>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import RouteNames from '@/types/routeNames';
  import EditVendorRequestPartRequest from '@/components/SpecialOccurrence/MaterialRequest/EditVendorRequestPartRequest.vue';
  import EditVendorRequestPartOrder from '@/components/SpecialOccurrence/MaterialRequest/EditVendorRequestPartOrder.vue';
  import ModalWindow from '@/components/ModalWindow.vue';
  import { VendorRequestPartEditDto } from '@/apiclient/apiclient_generated';
  import { materialRequestClient } from '@/apiclient/opsboardapi';

  @Component({
    components: { ModalWindow, EditVendorRequestPartOrder, EditVendorRequestPartRequest },
  })
  export default class EditVendorRequestPart extends Vue {
    materialRequestId: string;
    vendorRequestPart: VendorRequestPartEditDto = VendorRequestPartEditDto.fromJS({ part: { pn: '' } });
    vendorRequestPartId: string;

    created() {
      this.materialRequestId = this.$router.currentRoute.params.materialRequestId;
      this.vendorRequestPartId = this.$router.currentRoute.params.vendorRequestPartId;
    }

    async mounted() {
      this.$bvModal.show('editVendorRequestPart');
      await this.loadData();
    }

    async loadData() {
      this.vendorRequestPart = await materialRequestClient.getVendorRequestPartEditDto(this.vendorRequestPartId);
    }

    cancel() {
      this.$bvModal.hide('editVendorRequestPart');
    }

    modalClosed() {
      this.$router.push({ name: RouteNames.specialOccurrence.root, params: { occId: this.materialRequestId } });
    }
  }
</script>

<style lang="scss" scoped></style>
